<input type="text" (keyup)="onKeyUp($event)" [(ngModel)]="this.field.fieldValue" pInputText />
